import {Layout, Menu } from 'antd';
import React from 'react'
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { userLogout } from '../../actions/user';

const {Header} = Layout
export default function Headers() {
    const uri = useLocation().pathname
    const dispatch = useDispatch()

    const logout = () =>{
        dispatch(userLogout)
    }

  return (
    <Header>
    <div className="logo" />
    <Menu
      theme="dark"
      mode="horizontal"
      defaultSelectedKeys={['2']}
      style={{color:'white'}}
     >
        <Menu.Item><a href={process.env.PUBLIC_URL}>Home</a></Menu.Item>
        <Menu.Item><Link to="./../report"> Report Card</Link></Menu.Item>
        <Menu.Item><Link to="./../reportdetails"> Assessment Scores</Link></Menu.Item>
        <Menu.SubMenu title="Analysis">
            <Menu.Item><Link to="./../analysis">Chart</Link></Menu.Item>
            <Menu.Item><Link to="/home/report">Subject</Link></Menu.Item>
        </Menu.SubMenu>
        <Menu.Item onClick={logout}> Log Out</Menu.Item>
    </Menu>
  </Header>
  )
}
